import { FC } from 'react';

import type { BillingEntitlementKey } from '@/constants';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { getBillingEntitlementDefinition } from '@/shared/entitlements';

import SmallTooltip from '../../tooltips/SmallTooltip';

export interface BillingEntitlementLinkProps {
    entitlementKey: BillingEntitlementKey;
    label?: string;
}

const BillingEntitlementLink: FC<BillingEntitlementLinkProps> = ({ entitlementKey, label }): JSX.Element => {
    const { token } = useAntDesignTheme();
    const entitlement = getBillingEntitlementDefinition(entitlementKey);

    return (
        <SmallTooltip placement='topLeft' title={entitlement.description}>
            <a
                data-billing-entitlement={entitlementKey}
                href={entitlement.documentationUrl}
                rel='noopener noreferrer'
                target='_blank'
                style={{
                    color: 'inherit',
                    textDecorationColor: token.colorTextSecondary,
                    textDecorationLine: 'underline',
                    textDecorationStyle: 'dotted',
                    textUnderlineOffset: '0.2em',
                }}
            >
                {label ?? entitlement.label}
            </a>
        </SmallTooltip>
    );
};

export default BillingEntitlementLink;
